import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/products", label: "Products" },
  { to: "/quality", label: "Quality" },
  { to: "/contact", label: "Contact" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed top-0 inset-x-0 z-50 glass-nav" data-testid="main-nav">
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10 h-[72px] flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="group flex items-baseline gap-3">
          <span className="font-display text-2xl font-black tracking-tighter text-[#f5f5f5]">
            MSD<span className="text-[#D97736]">FOODS</span>
          </span>
          <span className="hidden sm:block font-mono-jb text-[10px] uppercase tracking-[0.3em] text-[#f5f5f5]/50">
            Est. Ahmedabad
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10" data-testid="nav-links-desktop">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `relative font-mono-jb text-xs uppercase tracking-[0.2em] transition-colors duration-300 ${
                  isActive ? "text-[#D97736]" : "text-[#f5f5f5]/70 hover:text-[#f5f5f5]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-cta-button"
            className="group flex items-center gap-2 bg-[#D97736] text-[#0a0a0a] font-mono-jb text-xs uppercase tracking-[0.15em] font-bold px-5 py-2.5 rounded-full transition-colors duration-300 hover:bg-[#e8904f]"
          >
            Enquire
            <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-[#f5f5f5] p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="nav-links-mobile"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="md:hidden overflow-hidden border-t border-white/10 bg-[#0a0a0a]/95"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {LINKS.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `font-display text-3xl font-bold tracking-tight ${
                      isActive ? "text-[#D97736]" : "text-[#f5f5f5]"
                    }`
                  }
                >
                  {l.label}
                </NavLink>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
